// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: window.location.protocol + '//' + window.location.hostname + ':6176/',

  // New Development Server
  // apiUrl: 'http://192.168.149.67:6180/bhp/api/v1/'

  // New Test Server

  // apiUrl: 'https://bhp-test.bandhan-konnagar.org:6181/bhp/api/v1/test/'

  // apiUrl: 'http://192.168.149.71:6181/bhp/api/v1/test/'

  // New Staging Server 
  // apiUrl: 'http://192.168.149.102:6182/bhp/api/v1/staging/'

  // Training
  // apiUrl: 'https://bhp-training.bandhan-konnagar.org:6184/bhp/api/v1/training/'

  // New Production Server
  apiUrl: 'https://bhp.bandhan-konnagar.org:6183/bhp/api/v1/prod/'

  // Soumen Machine
  // apiUrl: 'http://192.168.153.58:6180/bhp/api/v1/'
  // apiUrl : 'http://192.168.153.58:6182/bhp/api/v1/staging/'

  // Chayan Machine
  // apiUrl: 'http://192.168.153.160:6180/bhp/api/v1/'

  // Vivek Local Machine
  // apiUrl: 'http://192.168.153.243:6180/bhp/api/v1/'
};

// Local
// apiUrl: 'http://192.168.153.56:6180/bhp/api/v1/'
// Development
// apiUrl: 'http://192.168.149.229:6180/bhp/api/v1/'
// Test
// apiUrl: 'http://192.168.149.229:6181/bhp/api/v1/test/'
// apiUrl: 'https://192.168.149.71:6181/bhp/api/v1/test/'
// Staging
// apiUrl: 'http://192.168.149.221:6182/bhp/api/v1/staging/'
// Production
// apiUrl: 'http://192.168.149.221:6183/bhp/api/v1/prod/'
// apiUrl: 'http://122.186.245.217:6183/bhp/api/v1/prod/'

/*
 * For easier debugging in development mode, you can import the following filel
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
